import LegalLayout, { H2, P, UL } from "@/components/legal/LegalLayout";

export default function CookiePage() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Cookie Policy"
      updated="January 20, 2026"
      testid="cookie-page"
    >
      <P>
        This Cookie Policy explains how Qovarix uses cookies and similar technologies when you
        visit our website. We aim to keep tracking minimal and transparent.
      </P>

      <H2>1. What Are Cookies</H2>
      <P>
        Cookies are small text files placed on your device by websites you visit. They are widely
        used to make sites work, or work more efficiently, and to provide information to site
        owners.
      </P>

      <H2>2. Cookies We Use</H2>
      <UL>
        <li>
          <strong className="text-white">Strictly necessary:</strong> required for the site to
          function, including routing and basic session state.
        </li>
        <li>
          <strong className="text-white">Preferences:</strong> remember minor UI choices such as
          whether you have dismissed a banner.
        </li>
        <li>
          <strong className="text-white">Analytics (optional):</strong> if enabled, aggregated usage
          analytics to understand how visitors interact with the site. No personally identifying
          profile is built from this data.
        </li>
      </UL>
      <P>
        Qovarix does not use third-party advertising cookies and does not sell browsing data.
      </P>

      <H2>3. Local Storage</H2>
      <P>
        In addition to cookies, Qovarix may use browser local storage to persist lightweight
        preferences and 3D-scene quality settings. This data stays on your device.
      </P>

      <H2>4. Third Parties</H2>
      <P>
        Embedded links to Twitter/X, Discord, or similar platforms may set their own cookies when
        you click through. Their cookie practices are governed by their respective policies.
      </P>

      <H2>5. Managing Cookies</H2>
      <P>
        Most browsers allow you to view, manage, delete, or block cookies through their settings.
        Blocking strictly necessary cookies may prevent parts of the site from working correctly.
      </P>

      <H2>6. Changes</H2>
      <P>
        We may update this Cookie Policy as the Service evolves. Material changes will be reflected
        in the "Last updated" date above.
      </P>

      <H2>7. Contact</H2>
      <P>
        Questions about cookies? Email{" "}
        <a href="mailto:contact@blocknexalabs.com" className="text-[#00F0FF] hover:underline">
          contact@blocknexalabs.com
        </a>
        .
      </P>
    </LegalLayout>
  );
}
